import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a54c59e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-c-hub-gallery-header" }
const _hoisted_2 = { class: "hd-container" }
const _hoisted_3 = { class: "hd-c-hub-gallery-header__sections" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "hd-c-hub-gallery-header__additional-buttons" }
const _hoisted_6 = { class: "hd-c-hub-gallery-header__menu" }
const _hoisted_7 = { class: "hd-c-hub-gallery-header__menu-sections" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "hd-c-hub-gallery-header__menu-additional-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_lyra_asset, {
        class: "hd-c-hub-gallery-header__title",
        "asset-key": "app-title"
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
          return (_openBlock(), _createElementBlock("div", {
            key: section.endpointId,
            class: _normalizeClass(["hd-c-hub-gallery-header__section", { 'is-active' : _ctx.isActiveSection(section.endpointId) }]),
            onClick: ($event: any) => (_ctx.makeSectionActive(section))
          }, [
            _createVNode(_component_lyra_asset, {
              class: "hd-c-hub-gallery-header__section-title",
              "asset-key": `section-${section.endpointId}-title`
            }, null, 8, ["asset-key"])
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalButtons, (record) => {
          return (_openBlock(), _createBlock(_component_base_button, {
            key: record.buttonId,
            class: "hd-c-hub-gallery-header__additional-button",
            modifier: "light",
            callback: _ctx.processButton,
            callbackString: record.url
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lyra_asset, {
                "asset-key": `app-link-${record.buttonId}`
              }, null, 8, ["asset-key"])
            ]),
            _: 2
          }, 1032, ["callback", "callbackString"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_base_image_svg, {
          class: "hd-c-hub-gallery-header__menu-button",
          source: require(`!html-loader!../assets/icons/${_ctx.menuIcon}.svg`),
          onClick: _ctx.toggleMenu
        }, null, 8, ["source", "onClick"]),
        _createElementVNode("div", {
          class: _normalizeClass(["hd-c-hub-gallery-header__menu-container", { 'is-open': _ctx.isMenuActive }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
              return (_openBlock(), _createElementBlock("div", {
                key: section.endpointId,
                class: _normalizeClass(["hd-c-hub-gallery-header__section", { 'is-active' : _ctx.isActiveSection(section.endpointId) }]),
                onClick: ($event: any) => (_ctx.makeSectionActive(section))
              }, [
                _createVNode(_component_lyra_asset, {
                  class: "hd-c-hub-gallery-header__section-title",
                  "asset-key": `section-${section.endpointId}-title`
                }, null, 8, ["asset-key"])
              ], 10, _hoisted_8))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalButtons, (record) => {
              return (_openBlock(), _createBlock(_component_base_button, {
                key: record.buttonId,
                class: "hd-c-hub-gallery-header__additional-button",
                callback: _ctx.processButton,
                callbackString: record.url
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lyra_asset, {
                    "asset-key": `app-link-${record.buttonId}`
                  }, null, 8, ["asset-key"])
                ]),
                _: 2
              }, 1032, ["callback", "callbackString"]))
            }), 128))
          ])
        ], 2)
      ])
    ])
  ]))
}